/**
 * /settings/advertiser-api — advertiser API v2 console (FS-227 / DASH).
 *
 * Flat-file TanStack Router route: dots map to slashes, so
 * `settings.advertiser-api.tsx` mounts at `/settings/advertiser-api`.
 * Delegates all rendering to `AdvertiserApiV2Page` so the route stays a
 * thin wiring shim.
 */

import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { AdvertiserApiV2Page } from "@/features/advertiser-api-v2/AdvertiserApiV2Page";

// ---------------------------------------------------------------------------
// Search params — optional `advertiserId` deep-link so admins can land on a
// pre-selected advertiser (e.g. from an advertiser drilldown screen).
// ---------------------------------------------------------------------------

interface SettingsAdvertiserApiSearch {
	advertiserId?: string;
}

export const settingsAdvertiserApiRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/settings/advertiser-api",
	validateSearch: (
		raw: Record<string, unknown>,
	): SettingsAdvertiserApiSearch => {
		const v = raw.advertiserId;
		if (typeof v === "string" && v.trim().length > 0) {
			return { advertiserId: v.trim() };
		}
		return {};
	},
	component: AdvertiserApiV2Page,
});

export default settingsAdvertiserApiRoute;

// Re-export for convenience so the shared router wire-up can import either
// the route or the page component from a single module path.
export { AdvertiserApiV2Page } from "@/features/advertiser-api-v2/AdvertiserApiV2Page";
